<template>
<div class="info">
	<div class="title">{{title||'申请人信息'}}</div>
	<Form :label-width="150" class="mt15">
	    <FormItem label="公司名称：" class="w600">
	        {{info.companyName}}
	    </FormItem>
	    <FormItem label="统一社会信用代码：" class="w600">
	    	{{info.organizationCode}}
	    </FormItem>
	    <FormItem label="地区：" v-if="info.provinceName&&info.cityName&&info.areaName">
			{{info.provinceName+info.cityName+info.areaName}}
	    </FormItem>
		<FormItem label="实际经营地址：" class="w600">
	        {{info.address}}
	    </FormItem>
	    <FormItem label="联系人：" class="w600">
	        {{info.contactsName}}
	    </FormItem>
	    <FormItem label="联系电话：" class="w600">
	        {{info.contactsPhone}}
	    </FormItem>
	    <FormItem label="联系人邮箱：" class="w600">
	        {{info.contactsEmail}}
	    </FormItem>
	    <FormItem label="联系人证件号：" class="w600">
	        {{info.contactsCertificateNumber}}
	    </FormItem>
	    <FormItem label="营业执照：" class="w600" v-if="info.businessLicenseUrl">
	        <ImageShow :url="info.businessLicenseUrl" />
	    </FormItem>	
	</Form>
</div>
</template>
<script>
import ImageShow from '../../common/Image'
export default {
	components:{ ImageShow },
	props:{
		info:Object,
		title:String
	},
}
</script>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/common/ApplicantInfo.vue